import UserMessagesInboxEntry from './user_messages_inbox_entry';
import { closest } from '../toolkit/dom';

const WRAPPER_SELECTOR = '[data-user-messages-inbox-entries-wrapper]';

class UserMessagesInboxEntries {
  constructor(container) {
    this.container = container;
    let wrapper = closest(this.container, WRAPPER_SELECTOR);
    if (!(wrapper instanceof HTMLElement)) {
      throw new Error('Unable to locate wrapper element for inbox entries');
    }
    this.wrapper = wrapper;
    this.entries = [];
    this.parse();

    this.scrollToBottom();
  }

  parse() {
    let els = this.container.querySelectorAll('p');

    Array.prototype.forEach.call(els, el => {
      let entry = UserMessagesInboxEntry.parse(el);
      this.entries.push(entry);
    });
  }

  add(entry) {
    this.entries.push(entry);
    let el = entry.getElement();
    el.classList.add('new-entry');
    this.container.appendChild(el);

    this.scrollToBottom();
  }

  scrollToBottom() {
    this.wrapper.scrollTop = this.wrapper.scrollHeight;
  }
}

export default UserMessagesInboxEntries;



// WEBPACK FOOTER //
// ./src/javascripts/user_messages/user_messages_inbox_entries.js